import { createLocalVideoTrack } from "livekit-client";
import { useMediaTrack } from "@/hooks/livekit/useMediaTrack";

interface UseLocalVideoOptions {
  enabled?: boolean;
}

export function useLocalVideo(opts?: UseLocalVideoOptions) {
  return useMediaTrack(createLocalVideoTrack, "videoinput", opts?.enabled);
}
